import type { ComponentType, SVGProps } from "react";
import * as FlagIcons from "country-flag-icons/react/3x2";

type FlagComponent = ComponentType<SVGProps<SVGSVGElement>>;

const flags = FlagIcons as Record<string, FlagComponent>;

type Props = {
  iso: string;
  className?: string;
  title?: string;
};

/** SVG flags — works on Windows (unlike Unicode regional-indicator emojis). */
export function CountryFlag({ iso, className = "h-3.5 w-5 shrink-0 rounded-[2px]", title }: Props) {
  const code = iso.toUpperCase();
  const Flag = flags[code];
  if (!Flag) {
    return (
      <span className="inline-flex h-3.5 min-w-5 items-center justify-center text-[10px] font-bold text-[var(--ink-soft)]">
        {code}
      </span>
    );
  }
  return (
    <span className="inline-flex shrink-0" title={title}>
      <Flag className={className} aria-hidden />
    </span>
  );
}
